function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import classNames from 'classnames';
import React, { Component, Fragment } from 'react';
import { Button } from '..';
import { ModalBackButton, ModalBody, ModalClose, ModalFooter, ModalHeader, ModalInnerContainer, ModalOverlay, ModalScrollWrapper, ModalTitle, ModalTools, ModalWrapper } from "./Modal.styles";
export var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastOffset", [0, 0]);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ownRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      childRef: null,
      isClosing: false,
      isOpen: false,
      isOpening: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getRelativeOffset", function () {
      if (_this.props.parentRef && _this.ownRef) {
        var parentBoundry = _this.props.parentRef.getBoundingClientRect();

        var ownBoundry = _this.ownRef.getBoundingClientRect();

        var offsetX = parentBoundry.left - ownBoundry.left + _this.lastOffset[0];
        var offsetY = parentBoundry.top - ownBoundry.top + _this.lastOffset[1];
        _this.lastOffset = [offsetX, offsetY];
        return _this.lastOffset;
      }

      return [0, 0];
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openGuard", function () {
      if (_this.state.isOpening) {
        _this.lastOffset = [0, 0];
        setTimeout(function () {
          return _this.setState({
            isOpening: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closeGuard", function () {
      if (_this.state.isClosing) {
        setTimeout(function () {
          return _this.setState({
            isClosing: false,
            isOpen: false
          });
        }, 300);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyle", function () {
      if (_this.props.isFixed) {
        return {};
      }

      var _this$getRelativeOffs = _this.getRelativeOffset(),
          _this$getRelativeOffs2 = _slicedToArray(_this$getRelativeOffs, 2),
          left = _this$getRelativeOffs2[0],
          top = _this$getRelativeOffs2[1];

      return {
        left: left,
        top: top
      };
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var style = this.getStyle();

      if (this.props.parentRef && this.props.parentRef.style.position !== 'relative') {
        console.error("Modal's parent needs to be relative");
        return null;
      }

      var footer = this.props.footer ? this.props.footer : this.props.buttonControls ? this.props.buttonControls.map(function (button) {
        return React.createElement(Button, {
          disabled: button.disabled,
          key: button.label,
          onClick: button.onClick,
          htmlType: button.htmlType,
          type: button.type ? button.type : button.isActive ? Button.types.PRIMARY : Button.types.FLAT
        }, button.label);
      }) : undefined;
      return this.state.isOpen ? React.createElement(Fragment, null, React.createElement(ModalWrapper, {
        breakpoint: this.props.breakpoint,
        ref: function ref(_ref) {
          return _this2.ownRef = _ref;
        },
        style: style,
        isFixed: this.props.isFixed,
        className: classNames('modal__wrapper', this.props.className),
        isOpening: this.state.isOpening,
        isClosing: this.state.isClosing
      }, React.createElement(ModalScrollWrapper, {
        className: "modal__scroll-wrapper",
        isFixed: this.props.isFixed
      }, React.createElement(ModalInnerContainer, {
        className: "modal__inner-container",
        isFixed: this.props.isFixed
      }, this.props.isCloseVisible && React.createElement(ModalClose, {
        htmlType: "button",
        type: Button.types.ICON,
        icon: "closeL",
        onClick: this.props.onClose,
        className: "modal__close-button"
      }), React.createElement(ModalHeader, {
        className: "modal__header"
      }, React.createElement(ModalBackButton, {
        htmlType: "button",
        rotateButton: !this.props.backIcon,
        type: Button.types.ICON,
        icon: this.props.backIcon || 'chevronM',
        onClick: this.props.onClose
      }), React.createElement(ModalTitle, {
        className: "modal__title"
      }, this.props.name), this.props.toolsRenderer && React.createElement(ModalTools, {
        className: "modal__tools"
      }, this.props.toolsRenderer())), React.createElement(ModalBody, {
        className: "modal__body"
      }, this.props.children), footer && React.createElement(ModalFooter, {
        className: "modal__footer"
      }, footer)))), React.createElement(ModalOverlay, {
        isOpening: this.state.isOpening,
        isClosing: this.state.isClosing,
        onClick: this.props.closeOnOverlay ? this.props.onClose : undefined,
        className: "modal__overlay"
      })) : null;
    }
  }, {
    key: "releaseScroll",
    value: function releaseScroll() {
      if (this.props.isFixed && !this.props.isOpen) {
        document.body.removeAttribute('style');
      } else if (!this.props.isOpen) {
        var _arr2 = Array.from(document.body.children);

        for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
          var child = _arr2[_i2];
          child.style.pointerEvents = 'all';
        }
      }
    }
  }, {
    key: "blockScroll",
    value: function blockScroll() {
      if (this.props.isFixed && this.props.isOpen) {
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
      } else if (this.props.isOpen) {
        var _arr3 = Array.from(document.body.children);

        for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
          var child = _arr3[_i3];
          child.style.pointerEvents = 'none';
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.openGuard();

      if (this.props.isOpen) {
        this.blockScroll();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.openGuard();
      this.closeGuard();
      this.blockScroll();
      this.releaseScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.releaseScroll();
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (state.isOpen && !props.isOpen) {
        return {
          isClosing: true,
          isOpen: true,
          isOpening: false
        };
      }

      if (!state.isOpen && props.isOpen) {
        return {
          isClosing: false,
          isOpen: true,
          isOpening: true
        };
      }

      return null;
    }
  }]);

  return Modal;
}(Component);

_defineProperty(Modal, "defaultProps", {
  breakpoint: 'md',
  closeOnOverlay: true,
  isCloseVisible: false,
  isFixed: false,
  isOpen: false
});